import React from 'react';

const StepCard = ({data}) => {
    const {image, title, description} = data;
    console.log(image, title, description)
    return (
        <div className="card w-96 ">
                <div className="card-body items-center text-center">
                    <img src={image} alt="" />
                    <h2 className="card-title text-2xl font-bold text-primary mb-2.5">{title}</h2>
                    <p>{description}</p>
                    
                </div>
                </div>  
    );
};

export default StepCard;